module.exports = __webpack_public_path__ + "img/graph.665cc58b.png";